module.exports = __webpack_public_path__ + "static/event-7c3ba691e4a9abf3c9a780840f065adb.webp";